import { useMemo } from 'react';

import { useAuth } from '@/common/contexts/AuthContext';

const useFooter = ({ currentItems, disabled, isLoading }) => {
  const { user, zergRush } = useAuth();

  const isDisabled = useMemo(() => {
    const blocked = disabled || isLoading;
    const noSelection =
      blocked || currentItems.filter((item) => item.is_selected).length === 0;

    return {
      disabled: blocked,
      loading: isLoading,
      validate:
        blocked ||
        noSelection ||
        zergRush ||
        !user?.functionality_accesses?.carts_order_validate,
    };
  }, [currentItems, disabled, isLoading, user, zergRush]);

  return {
    isDisabled,
  };
};

export default useFooter;
